import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import config from "../config";
import { createSales } from "../api/salesApi";

const PaymentSuccess = () => {
  const location = useLocation();
  const state = location.state || {};
  console.log("Payment success location state:", state);

  const processPaymentResult = async () => {
    try {
      const currentSubRaw = localStorage.getItem("pendingSubscription");
      const currentSub = currentSubRaw ? JSON.parse(currentSubRaw) : null;

      const actionType = localStorage.getItem("actionType");
      const couponData = localStorage.getItem("coupon");
      const coupon = couponData ? JSON.parse(couponData) : null;

      let discount = 0;

      if (coupon) {
        if (coupon.discount_type === "percentage") {
          discount =
            ((Number(state["Response.Amount"]) / 100) * coupon.discount_value) /
            100;
        } else {
          discount = coupon.discount_value;
        }
      }
      console.log("Payment success subscription", currentSub);
      const response = await fetch(`${config.apiUrl}/process-payment-result`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          transactionId: state["Response.PUN"],
          decision: "ACCEPT",
          authCode: state["Response.ConfirmationID"],
          amount: Number(state["Response.Amount"]) / 100,
          duration: currentSub?.duration_days,
          referenceNumber: state["Response.MerchantModuleSessionID"],
        }),
      });

      const result = await response.json();
      console.log("Payment processing result:", result);

      //Create Sales

      if (result.success && result.status === "completed") {
        // 4. Prepare sales data
        const salesData = {
          client_subscription_id: currentSub.client_subscription_id,
          client_id: currentSub.client_id,
          price: Number(state["Response.Amount"]) / 100,
          payment_type: "ONLINE",
          action: actionType || "CARD",
          coupon_id: coupon?.coupon_id || null,
          discount: discount,
          total: Number(state["Response.Amount"]) / 100,
        };

        // 5. Call your createSales function (assumes it's imported or defined)
        const newSales = await createSales(salesData);
        console.log("Sales record created:", newSales);

        // 6. Clear localStorage
        localStorage.removeItem("pendingSubscription");
        localStorage.removeItem("actionType");
        localStorage.removeItem("coupon");
      } else {
        console.warn("Payment not marked as completed:", result);
      }
    } catch (error) {
      console.error("Error processing payment result:", error);
    }
  };

  useEffect(() => {
    if (state["Response.PUN"] && state["Response.ConfirmationID"]) {
      processPaymentResult();
    }
  }, [state]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-lg sm:rounded-lg sm:px-10">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
              <svg
                className="h-8 w-8 text-green-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h2 className="mt-6 text-2xl font-extrabold text-gray-900">
              Payment Successful
            </h2>
            <div className="mt-4 text-gray-600">
              <p className="font-medium">
                Transaction ID: {state["Response.PUN"]}
              </p>
              <p className="font-medium">
                Amount: {Number(state["Response.Amount"]) / 100}
              </p>
              <p className="font-medium">
                Status: {state["Response.StatusMessage"]}
              </p>
              <p className="font-medium">
                Date: {state["Response.EZConnectResponseDate"] || new Date()}
              </p>
            </div>
            <div className="mt-8">
              <Link
                to="/"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Return to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
